import React, { useRef } from 'react';
import styled from 'styled-components';
import BlackboxPosition from '@catalogo/core-blackbox/position';
import IframeUrl from '@catalogo/ui-americanas-desktop-iframeurl';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box-new';
import { withConfig } from '@catalogo/core-connect/config';
import InfoDisclaimers from './components/info-disclaimers';

const WrapperProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Content = styled.div`
  background-color: #fff;
  word-wrap: break-word;
`;

const Description = styled.div`
  background: #fff;
  word-break: break-word;
  font-size: 14px;
  color: #666;
  font-family: Helvetica Neue, Helvetica, Arial, Sans-Serif;
`;

const Container = styled.div`
  background-color: #fff;
  word-wrap: break-word;
`;

const isServer = typeof window === 'undefined';

export const ProductInfo = ({ publication, description, categories, page }) => {
  const ref = useRef(null);
  const isIframe = !!page?.components?.['produto-descricao'];
  const handleDescription = () => {
    const { content, type } = description || {};
    if (type === 'url') {
      return <IframeUrl src={content} />;
    }

    if (type === 'html') {
      if (isServer) {
        return null;
      }

      const blob = new Blob([content], { type: 'text/html' });
      const url = URL.createObjectURL(blob);

      return <IframeUrl src={url} />;
    }

    return <Description dangerouslySetInnerHTML={{ __html: content }} />;
  };

  const rendeInfoContent = () => {
    if (publication && publication.children && publication.children.length > 0) {
      return (
        <Content>
          <BlackboxPosition position="produto-descricao" publication={publication} />
        </Content>
      );
    }

    return handleDescription();
  };

  return (
    <AccordionBox
      id="info-section"
      ref={ref}
      title="Informações do produto"
      htmlElTitle="h2"
      initialDefaultHeight={250}
      shouldGetElementHeightOnRender={!isIframe}
      visibilityOnInit={true}
      expandContentOption={true}
      metricId="informações produto"
      anchorRef="#info-section"
    >
      <WrapperProductInfo>
        <Container>
          <InfoDisclaimers categories={categories} />
          {rendeInfoContent()}
        </Container>
      </WrapperProductInfo>
    </AccordionBox>
  );
};

export default withConfig(ProductInfo);
